package ui.app.assign.detail.kindergarten.editor.page

import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import api.ResourceOrientation
import api.ResourceType
import apps.App
import com.mohamedrejeb.richeditor.ui.material3.RichText
import compose.assets.Svg
import compose.assets.svg.DeleteEmpty
import compose.assets.svg.Music_note
import compose.assets.svg.Plus
import ssoft.frontend.generated.resources.Res
import ssoft.frontend.generated.resources.layer_bottom__kindergarten_audio_tooltip
import tools.GlobalObjectShare
import tools.rememberRichTextState
import ui.app.assign.detail.kindergarten.editor.AppKindergartenEditorScope
import ui.app.assign.detail.kindergarten.editor.NextAndSkip
import ui.resource.ResourceListingArgs

@Composable
fun AppKindergartenEditorScope.KindergartenPage05Audio(nnvl: AppKindergartenEditorScope.Wrapper) {

    val imagePickerKey = "KindergartenPage05Audio"

    GlobalObjectShare.Consumer(imagePickerKey)

    val adapter = remember {
        nnvl.adapterAudio
    }

    fun openResourcePicker() {
        GlobalObjectShare.launchImagePicker(
            key = imagePickerKey,
            nav = nav,
            args = ResourceListingArgs(
                companyId = args.companyId,
                restrictionOrientation = ResourceOrientation.UNDEFINED.mask,
                restrictionType = ResourceType.AUDIO.mask,
                restrictionCanIgnoreAspectRatio = true,
                excluded = adapter.state.joinToString { it.resource.state.toString() }
            )
        ) {
            it.firstOrNull()?.also {
                adapter.add(
                    index = 0,
                    newItem = App.Kindergarten.Audio(
                        resource = it.id,
                        name = it.name,
                        duration = it.duration
                    )
                )
            }
        }
    }

    Box(Modifier.fillMaxSize()) {

        if (adapter.state.isEmpty()) {
            RichText(
                state = rememberRichTextState(Res.string.layer_bottom__kindergarten_audio_tooltip),
                modifier = Modifier.align(Alignment.TopCenter)
                    .padding(16.dp)
            )
        } else {
            LazyColumn(
                modifier = Modifier.fillMaxSize(),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.spacedBy(16.dp),
                contentPadding = PaddingValues(
                    start = 16.dp,
                    end = 16.dp,
                    top = 16.dp,
                    bottom = 32.dp
                )
            ) {
                items(adapter.state) {
                    AudioItem(it) {
                        adapter.removeAll { entry -> entry.resource.state == it.resource.state }
                    }
                }
            }
        }

        NextAndSkip(Modifier.align(Alignment.BottomCenter).padding(16.dp))

        FloatingActionButton(
            onClick = { openResourcePicker() },
            modifier = Modifier.align(Alignment.BottomEnd).padding(16.dp)
        ) {
            Icon(Svg.Plus, null)
        }
    }
}

@Composable
private fun AppKindergartenEditorScope.AudioItem(
    item: AppKindergartenEditorScope.WrapperAudioEntry.Item,
    onDelete: () -> Unit
) {
    Card(Modifier.width(512.dp)) {
        Row(
            horizontalArrangement = Arrangement.spacedBy(8.dp),
            modifier = Modifier.padding(4.dp)
        ) {
            Icon(
                imageVector = Svg.Music_note,
                contentDescription = null,
                modifier = Modifier.align(Alignment.CenterVertically)
            )
            TextField(
                value = item.name.text,
                onValueChange = { item.name.set(it) },
                modifier = Modifier.weight(1F)
            )
            SmallFloatingActionButton(
                onClick = onDelete,
                modifier = Modifier.align(Alignment.Top)
                    .padding(8.dp)
            ) {
                Icon(Svg.DeleteEmpty, null)
            }
        }
    }
}